import React, { useEffect, useState } from "react";
import "../styles/register.css";
import { useParams } from "react-router-dom";
import vendorsVerify from "../services/vendors-verification";

import EmailVerification from "../assets/images/email-verification.jpg";

const EmailVerificationPage = () => {
  const { vendorGuid } = useParams();
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await vendorsVerify.verify(vendorGuid);
        if (response.isSuccess) {
          setVerificationStatus({
            success: true,
            message: response.message,
          });
        } else {
          setVerificationStatus({
            success: false,
            message: response.message || "Verification failed.",
          });
        }
        setApiError("");
      } catch (error) {
        setApiError(error.message || "An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [vendorGuid]);

  return (
    <>
      <section className="registration-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-sm-12 col-xs-12 text-center">
              <div className="verification-box">
                <img src={EmailVerification} alt="Email Verification" />
                <div className="verification-page">
                  <h2>Email Verification</h2>
                  {loading ? (
                    <p>Verifying your email...</p>
                  ) : (
                    <div>
                      {verificationStatus ? (
                        <p
                          className={
                            verificationStatus.success
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {verificationStatus.message}
                        </p>
                      ) : (
                        <p className="text-danger">Verification failed.</p>
                      )}
                      {apiError && <p className="text-danger">{apiError}</p>}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EmailVerificationPage;
